import React from "react";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function ObservationsPieChart({ observations }) {
  // Compter positifs et négatifs
  const positives = observations.filter(obs => obs.positive).length;
  const negatives = observations.filter(obs => !obs.positive).length;

  const data = {
    labels: ["Positives", "Négatives"],
    datasets: [
      {
        data: [positives, negatives],
        backgroundColor: ["#4CAF50", "#F44336"], // Vert = positif, Rouge = négatif
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const total = positives + negatives;
            const value = context.raw;
            const percent = ((value / total) * 100).toFixed(1);
            return `${context.label}: ${value} (${percent}%)`;
          },
        },
      },
    },
  };

  return (
    <div className="w-96 mx-auto h-60 flex justify-center  bg-white rounded-xl shadow-md">
      <Pie data={data} options={options} />
    </div>
  );
}
